import intl from "react-intl-universal";

// 支持的语言列表
export const SUPPORTED_LOCALES = {
  "zh-CN": "中文",
  "en-US": "English",
} as const;

export type Locale = keyof typeof SUPPORTED_LOCALES;

// 语言资源文件
export const locales = {
  "zh-CN": {
    // Header 相关
    "header.logo": "VPN 指南",
    "header.nav.links": "首页",
    "header.nav.tools": "工具",
    "header.nav.faq": "FAQ",
    "header.nav.datacard": "流量卡",
    "header.theme.toggle": "切换主题",
    "header.menu.toggle": "切换菜单",

    "landing.title": "高级VPN服务",
    "landing.description":
      "探索一个精心策划的VPN服务列表，提供直接链接到它们网站的链接。找到适合您需求的完美VPN，开始安全浏览。",

    "landing.help.title": "需要帮助选择？",
    "landing.help.description":
      "每个VPN服务都提供独特的功能和优势。比较它们的提供，选择最适合您隐私和安全需求的VPN。",
    "landing.help.secure": "安全 & 私密",
    "landing.help.fast": "快速连接",
    "landing.help.global": "全球服务器",

    // FAQ 相关
    "faq.title": "常见问题",
    "faq.tips1": "什么是VPN？",
    "faq.subTips1":
      "VPN（虚拟专用网络）是一种通过加密连接保护您的在线隐私和安全的技术。",
    "faq.tips2": "为什么需要使用VPN？",
    "faq.subTips2":
      "VPN可以保护您的隐私、绕过地理限制、在公共WiFi上保护您的数据安全。",
    "faq.tips3": "如何选择VPN服务？",
    "faq.subTips3":
      "选择VPN时需要考虑速度、安全性、服务器位置、价格和客户支持等因素。",
    "faq.tips4": "VPN是否合法？",
    "faq.subTips4": "在大多数国家，VPN是合法的。但请确保遵守当地法律法规。",
    "faq.tips5": "VPN会影响网速吗？",
    "faq.subTips5": "VPN可能会轻微影响网速，但现代VPN服务通常影响很小。",
    "faq.tips6": "如何设置VPN？",
    "faq.subTips6": "通常只需下载VPN应用，注册账户，然后连接到服务器即可。",
    "faq.tips7": "免费VPN安全吗？",
    "faq.subTips7": "免费VPN可能存在安全风险，建议选择可靠的付费服务。",
    "faq.tips8": "VPN可以访问被封锁的网站吗？",
    "faq.subTips8": "是的，VPN可以帮助您访问被地理限制或封锁的网站。",

    "footer.productName": "VPNS Guide",
    "footer.companyInfoDescription":
      "您的VPN信息和工具的可靠资源，帮助您保护在线隐私。",
    "footer.reserved": "保留所有权利",
    "footer.resources": "资源",
    "footer.faq": "FAQ",
    "footer.home": "首页",
    "footer.tools": "工具",
    "footer.help": "帮助",
    "footer.privacyPolicy": "隐私政策",
    "footer.termsOfService": "服务条款",
    "footer.contact": "联系我们",
  },
  "en-US": {
    // Header related
    "header.logo": "VPN Guide",
    "header.nav.links": "Home",
    "header.nav.tools": "Tools",
    "header.nav.faq": "FAQ",
    "header.nav.datacard": "Data Card",
    "header.theme.toggle": "Toggle theme",
    "header.menu.toggle": "Toggle menu",

    "landing.title": "Premium VPN Services",
    "landing.description":
      "Explore a curated list of VPN services with direct links to their websites. Find the perfect VPN for your needs and start browsing securely today.",

    "landing.help.title": "Need Help Choosing?",
    "landing.help.description":
      "Each VPN service offers unique features and benefits. Compare their offerings and choose the one that best fits your privacy and security needs.",
    "landing.help.secure": "Secure & Private",
    "landing.help.fast": "Fast Connections",
    "landing.help.global": "Global Servers",

    // FAQ related
    "faq.title": "Frequently Asked Questions",
    "faq.tips1": "What is a VPN?",
    "faq.subTips1":
      "A VPN (Virtual Private Network) is a technology that protects your online privacy and security through encrypted connections.",
    "faq.tips2": "Why do I need a VPN?",
    "faq.subTips2":
      "VPNs protect your privacy, bypass geographic restrictions, and secure your data on public WiFi.",
    "faq.tips3": "How do I choose a VPN service?",
    "faq.subTips3":
      "When choosing a VPN, consider speed, security, server locations, price, and customer support.",
    "faq.tips4": "Are VPNs legal?",
    "faq.subTips4":
      "VPNs are legal in most countries, but make sure to comply with local laws and regulations.",
    "faq.tips5": "Do VPNs affect internet speed?",
    "faq.subTips5":
      "VPNs may slightly affect internet speed, but modern VPN services typically have minimal impact.",
    "faq.tips6": "How do I set up a VPN?",
    "faq.subTips6":
      "Usually, you just need to download a VPN app, register an account, and connect to a server.",
    "faq.tips7": "Are free VPNs safe?",
    "faq.subTips7":
      "Free VPNs may pose security risks, so it's recommended to choose a reliable paid service.",
    "faq.tips8": "Can VPNs access blocked websites?",
    "faq.subTips8":
      "Yes, VPNs can help you access websites that are geographically restricted or blocked.",

    "footer.productName": "VPNS Guide",
    "footer.companyInfoDescription":
      "Your trusted resource for VPN information and tools to protect your online privacy.",
    "footer.reserved": "All Rights Reserved",
    "footer.resources": "Resources",
    "footer.faq": "FAQ",
    "footer.home": "Home",
    "footer.tools": "Tools",
    "footer.help": "Help",
    "footer.privacyPolicy": "Privacy Policy",
    "footer.termsOfService": "Terms of Service",
    "footer.contact": "Contact Us",
  },
};

function getDefaultLocale(): Locale {
  const preferredLanguage =
    typeof navigator !== "undefined"
      ? typeof navigator.language === "string" && navigator.language.length > 0
        ? navigator.language
        : Array.isArray(navigator.languages)
          ? (navigator.languages.find(
              (language): language is string =>
                typeof language === "string" && language.length > 0,
            ) ?? null)
          : null
      : null;

  if (preferredLanguage?.includes("zh")) {
    return "zh-CN";
  }

  return "en-US";
}

// 初始化状态
let isInitialized = false;

// 初始化国际化
export function initI18n(locale: Locale = getDefaultLocale()) {
  const fallbackLocale = getDefaultLocale();

  if (isInitialized) {
    // 如果已经初始化，只更新语言

    intl.init({
      currentLocale: locale,
      locales,
      fallbackLocale,
    });
    return;
  }

  intl.init({
    currentLocale: locale,
    locales,
    fallbackLocale,
  });
  isInitialized = true;
}

// 获取当前语言
export function getCurrentLocale(): Locale {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("locale") as Locale;
    return saved && SUPPORTED_LOCALES[saved] ? saved : getDefaultLocale();
  }
  return getDefaultLocale();
}

// 设置语言
export function setLocale(locale: Locale) {
  if (typeof window !== "undefined") {
    localStorage.setItem("locale", locale);
    initI18n(locale);
  }
}

// 安全的获取翻译文本
export function getText(key: string, fallback?: string): string {
  if (!isInitialized) {
    // 如果还没初始化，返回默认语言的内容或fallback
    const defaultLocale = locales[getDefaultLocale()];
    return (defaultLocale as any)[key] || fallback || key;
  }
  return intl.get(key) || fallback || key;
}

// 导出 intl 实例
export { intl };
